// extracted by mini-css-extract-plugin
module.exports = {"container":"MiniBotsList_container__1jkvf","skeleton":"MiniBotsList_skeleton__2jluC","emptyBots":"MiniBotsList_emptyBots__ZjMHf","text":"MiniBotsList_text__1gUJm"};